const API_URL = 'https://acc.lacran.com/';

export function httpGetAsync(restUrl, callback) {
  var xmlHttp = new XMLHttpRequest();
  xmlHttp.onreadystatechange = function () {
    if (xmlHttp.readyState === 4 && xmlHttp.status === 200) callback(xmlHttp.responseText);
  };
  xmlHttp.open('GET', API_URL + restUrl, true); // true for asynchronous
  xmlHttp.send(null);
}

export function httpPostAsync(restUrl, data, callback) {
  var xmlHttp = new XMLHttpRequest();
  xmlHttp.onreadystatechange = function () {
    if (xmlHttp.readyState === 4 && xmlHttp.status === 200) callback(xmlHttp.responseText);
  };
  xmlHttp.open('GET', API_URL + restUrl, true); // true for asynchronous
  xmlHttp.send(data);
}
